import { render, staticRenderFns } from "./ElRoleNegalima.vue?vue&type=template&id=96024fcc&scoped=true&"
import script from "./ElRoleNegalima.vue?vue&type=script&lang=js&"
export * from "./ElRoleNegalima.vue?vue&type=script&lang=js&"
import style0 from "./ElRoleNegalima.vue?vue&type=style&index=0&id=96024fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96024fcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
